import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api, { ContentProviderAccountDto } from 'api';
import { isAdmin } from '../../utils/userUtils';
interface AuthSliceState {
	userInfo: ContentProviderAccountDto | null;
	isAdmin: Boolean | null;
}

const initialState: AuthSliceState = {
	userInfo: null,
	isAdmin: null,
};

export const checkUserRole = createAsyncThunk(
	'auth/checkUserRole',
	async (getIdTokenClaims: Function) => {
		return getIdTokenClaims();
	},
);

export const updateUserAccountDetails = createAsyncThunk(
	'auth/updateAccountDetails',
	async (data: any) => {
		return api.updateAccountDetails(data);
	},
);

export const getUserInfo = createAsyncThunk('auth/getUserInfo', async () => {
	return api.getCPAccountDetails();
});

export const getTermsAndConditions = createAsyncThunk(
	'auth/getLatestTermsAndConditions',
	async () => {
		return api.getLatestTermsAndConditions(false);
	},
);
export const acceptTermsAndConditions = createAsyncThunk(
	'auth/acceptTermsAndConditions',
	async () => {
		return api.acceptTermsAndConditions(undefined);
	},
);
export const resendVerificationEmail = createAsyncThunk(
	'auth/resendVerificationEmail',
	async () => {
		return api.resendVerificationEmail();
	},
);

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getUserInfo.fulfilled, (state, action) => {
			state.userInfo = action.payload;
		});
		builder.addCase(checkUserRole.fulfilled, (state, action) => {
			state.isAdmin = isAdmin(action.payload);
		});
	},
});

const { reducer } = authSlice;

export default reducer;
